import { create } from 'zustand';

import useAgentStore from '@/features/Agent/stores';
import useProductStore from '@/features/Product/store/ProductStore';
import useReportStore from '@/features/Report/store/ReportStore';
import useFeedbackSourceStore from '@/stores/Feedback/FeedbackSourceStore';
import useIntegrationStore from '@/stores/IntegrationStore';
import useSocketStore from '@/stores/SocketStore';

import useCompanyStore from '../../features/Account/store';
import useAttachmentStore from '../AttachmentStore';
import useDashboard2Store from '../Dashboard2Store';
import useEditorStoreTemp from '../EditorStoreTemp';
import useFeedbackListStore from '../Feedback/FeedbackListStore';
import useGlobalSearchStore from '../GlobalSearchStore';
import useHeySynclyStore from '../HeySynclyStore';
import useTagStore from '../TagStore';
import useTaxonomyStore from '../TaxonomyStore';
import useUserStore from '../UserStore';
import useWorkspaceStore from '../WorkspaceStore';
import useDetailModalStore from './DetailModalStore';
import useModalStore from './ModalStore';

type PathHistory = {
  prev: string;
  current: string;
};

type States = {
  appInit: boolean;
  appLoadingState: boolean;
  appPathHistory: PathHistory;
};

type Actions = {
  setState: <T extends keyof States>(state: Record<T, States[T]>) => void;
  initWholeStore: () => void;
  initStoreWhenChangeWorkspace: () => void;
  setAppPathHistory: (when: keyof PathHistory, path: string) => void;
};

const useCommonStore = create<States & Actions>((set, get) => ({
  appInit: false,
  appLoadingState: false,
  appPathHistory: {
    prev: '',
    current: '',
  },
  setState(state) {
    set(state);
  },
  initWholeStore: () => {
    const { initUserStore } = useUserStore.getState();

    get().initStoreWhenChangeWorkspace();
    initUserStore();
  },
  initStoreWhenChangeWorkspace: () => {
    set({ appInit: false });
    useAgentStore.getState().initAgentStore();
    useAttachmentStore.getState().initAttachemntStore();
    useCompanyStore.getState().initCompanyStore();
    useEditorStoreTemp.getState().initEditorStore();
    useFeedbackListStore.getState().initFeedbackStore();
    useTagStore.getState().initTagStore();
    useGlobalSearchStore.getState().initSearchStore();
    useDetailModalStore.getState().initModal();
    useModalStore.getState().initModalStore();
    useWorkspaceStore.getState().initWorkspaceStore();
    useFeedbackSourceStore.getState().initFeedbackSource();
    useSocketStore.getState().initSocketStore();
    useIntegrationStore.getState().initIntegrationStore();
    useTaxonomyStore.getState().initTaxonomyStore();
    useDashboard2Store.getState().initDashboard2Store();
    useReportStore.getState().initReportStore();
    useProductStore.getState().initProductStore();
    useHeySynclyStore.getState().initHeySynclyStore();
  },
  setAppPathHistory: (when, path) => {
    const { appPathHistory } = get();
    set({ appPathHistory: { ...appPathHistory, [when]: path } });
  },
}));

export default useCommonStore;
